import authService, { JWT_KEY } from '@/api/authService'
import { mapActions } from 'vuex'
import { MODULE_NAME, ACTIONS } from '@/store/site/constants'

export default {
  name: 'AppShell',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {
  },
  created () {
    this.authService = authService // for debugging purposes
    authService.restoreAuth()
    window.addEventListener('focus', this.onFocus)
    this[ACTIONS.FETCH_CONFIG]()
  },
  destroyed () {
    authService.clearRefreshTimer()
    window.removeEventListener('focus', this.onFocus)
  },
  methods: {
    ...mapActions(MODULE_NAME, Object.values(ACTIONS)),
    onFocus () {
      const authData = authService.authData || JSON.parse(localStorage.getItem(JWT_KEY) || 'null')
      if (authData &&
        authService.isExpired(authData.accessExpireTime) &&
       !authService.isExpired(authData.refreshExpireTime)) {
        authService.restoreAuth()
      }
    }
  }
}
